<div class="box">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div>
      <span
        *ngIf="
          hearingRequest?.hearingStatusCode == StatusType.AdjouredSineDie ||
            hearingRequest?.hearingStatusCode ==
              StatusType.AdjournmentSineDiePending;
          else nonSineDie
        "
      >
        Sine Die
      </span>
      <ng-template #nonSineDie>
        <span>
          {{ hearingRequest?.requestedHearingStartDate | date: 'longDate' }} ({{
            hearingRequest?.justice | incomplete
          }})
        </span>
      </ng-template>

      <span
        class="status"
        [ngClass]="
          hearingRequest?.hearingStatusCode
            | hearingBadgeStatusColor: hearingRequest?.requestedHearingStartDate
        "
        >{{
          hearingRequest?.hearingStatusCode
            | hearingBadgeStatus: hearingRequest?.requestedHearingStartDate
        }}</span
      >
    </div>

    <div
      *ngIf="
        !(
          hearingRequest?.hearingStatusCode == StatusType.AdjouredSineDie ||
          hearingRequest?.hearingStatusCode ==
            StatusType.AdjournmentSineDiePending
        )
      "
    >
      <a routerLink="{{ hearingDetailsRoute }}{{ hearingRequest?.id }}"
        >View details ></a
      >
    </div>
  </div>
</div>
